module.exports = require("./ar-DJ.d.ts");